import {FC, useEffect, useRef, useState} from 'react'
import {Step1} from './steps/Step1'
import {Step2} from './steps/Step2'
import {Step3} from './steps/Step3'
import {Step4} from './steps/Step4'
import {Formik, Form, FormikValues} from 'formik'
import {ICreateLicense, createLicenseSchemas, inits} from './CreateLicenseHelper'
import {KTSVG} from '../../../../../../../_metronic/helpers'
import {StepperComponent} from '../../../../../../../_metronic/assets/ts/components/_StepperComponent'
import {useIntl} from 'react-intl'
import {AnimaBaixo} from '../../../../../../../_metronic/assets/animation/styles'
import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'
import axios from 'axios'
import {Licenses} from '../../../components/licenses-list/core/_models'
import {CardLoading} from '../../../../../../../_metronic/partials/widgets/loading/CardLoading'
import {Skeleton} from 'primereact/skeleton'
// import {useCookies} from 'react-cookie'
// import {usePermissions} from '../../../../../../../hook/permissions'

const API_URL = process.env.REACT_APP_API_URL || 'api'

// const Cookies =
//   'XSRF-TOKEN=eyJpdiI6ImFLSUVqS1VOZndydEZVemVReW9QVGc9PSIsInZhbHVlIjoiWTgxMndSV3dwTmNzVjlZby9qQzZReXgvQVVNaFN0cU9Xa09ScTlJOGNvYmkzYTJWaWY5S0JURlBOMmlyd0pWU0tLWE9Mb1VVVTlGQ3ZNRldOcG9YWVBUc2ZIck1oS0RYVndWd1VzZzgwTzlwZlFwNkZTRFB0blJYa0JGT2JHNEkiLCJtYWMiOiI4ZGEyN2FmOWNmOTE0N2ZlYTIwODZiMmQ3OGZkODRhNTg5NTJkNzA0MzE2NGRhY2YxYmQzNjdmNWE0NzU2MjhkIiwidGFnIjoiIn0%3D; baseteste_session=eyJpdiI6Ink3VnY3aXB2blFmVlluS1c2RjFYVVE9PSIsInZhbHVlIjoiVmZEV1c1dENoSTF5bW1MS2hJQXkwc0U3VHBEWE4rM2F0MW9ZckYzeEdhcC81K1hSUWtEdkdPdTRoVGRZR0dmbzNQOExuV0hVS2xvV3R1MlZoek1PSldHN1lWTUVIR2NKZ3hTM09sSHBQWlBmbm9KaVp4TnZ2djl4ZjRBNGtjdUgiLCJtYWMiOiJlYTgxNzZmNGUzYzExZmU1NTMzY2E5Mzk2ODgyNjNkMTAyNmNlNTM3YjE3NjE3YjY2NWMyNGEzOTQyOTQyODQ0IiwidGFnIjoiIn0%3D'

interface props {
  data?: Licenses
}

const Vertical: FC<props> = ({data}) => {
  // const {show, create, edit} = usePermissions('Licenças66')
  // console.log('PERMISSIONS', show, edit, create)

  //BUSCA TOKEN NO LOCALSTORAGE
  let token = localStorage.getItem('auth_storage')
  if (token) token = token.replace(/['"]+/g, '')

  const navigate = useNavigate()
  const intl = useIntl()
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [currentSchema, setCurrentSchema] = useState(createLicenseSchemas[0])
  const [initValues] = useState<ICreateLicense>(inits)
  const [loading, setLoading] = useState(false)
  const [passos, setPassos] = useState(1)
  const totalpassos = 4
  const [timeLoad, setTimeLoad] = useState(false)

  useEffect(() => {
    getParameters()
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getParameters = async () => {
    if (data?.licenseAlertDay) {
      let parameter = []
      for (let i = 0; i < data?.licenseAlertDay.length; i++) {
        const field: any = {
          value: data?.licenseAlertDay[i].renovation_alert_day,
          label: data?.licenseAlertDay[i].renovation_alert_day?.toString(),
        }
        parameter.push(field as any)
      }
      console.log('ALERT BANCO', parameter)
      initValues.renovation_alert_days = parameter
    }
  }

  setTimeout(() => {
    setTimeLoad(true)
  }, 5000)

  //preenche os valores do formulário
  initValues.license_number = data?.license_number || ''
  initValues.description = data?.description || ''
  initValues.control_conditionings = data?.control_conditionings || false
  initValues.status = data?.status || 'valid'

  data?.project?.id ? (initValues.project_id = data?.project.id) : (initValues.project_id = 0)
  initValues.responsiblesT = data?.responsibles

  //VALORES INSERIDOS APENAS PARA TESTE - REMOVER DEPOIS QUE A API ESTIVER PRONTA
  //initValues.project_id = 22
  initValues.entrepreneur_id = data?.entrepreneur?.id || 0
  initValues.license_type_id = data?.licenseType?.id || 0

  // initValues.responsibles = data?.responsibles
  // initValues.responsibles = data.responsibles || []

  initValues.parentsLicense = data?.parentsLicense

  initValues.enterprise_id = data?.enterprises
  initValues.issue_organ_id = data?.issueOrgan?.id || 0

  initValues.responsible = data?.responsible || ''
  initValues.responsiblesT = data?.responsibles
  initValues.field_id = data?.fields
  initValues.enterprise_id = data?.enterprises
  // FIM VALORES INSERIDOS APENAS PARA TESTE - REMOVER DEPOIS

  //datas
  initValues.uuid = data?.uuid || ''
  initValues.issue_date = data?.issue_date || ''
  initValues.expiration_date = data?.expiration_date || ''
  initValues.limit_renovation = data?.limit_renovation || ''
  initValues.renovation_request_date = data?.renovation_request_date || ''
  initValues.finalization_date = data?.finalization_date || ''
  initValues.file = data?.file as any

  initValues.licenseAlertDay = data?.licenseAlertDay
  //preenche os valores do formulário com padrão da moeda brasileira
  initValues.renovation_cost = data?.renovation_cost?.replaceAll('.', '').replace(',', '.')
  initValues.issue_cost = data?.issue_cost?.replaceAll('.', '').replace(',', '.')
  initValues.maintenance_cost = data?.maintenance_cost?.replaceAll('.', '').replace(',', '.')
  initValues.file = data?.file as any

  const clickStep = (passo: number) => {
    if (!stepper.current) {
      return
    }
    while (stepper.current.currentStepIndex !== passo) {
      if (stepper.current.currentStepIndex > passo) {
        prevStep()
      } else {
        nextStep()
      }
    }
  }

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  const prevStep = () => {
    if (!stepper.current) {
      return
    }
    setPassos(stepper.current.currentStepIndex - 1)
    stepper.current.goPrev()
  }

  const nextStep = () => {
    if (!stepper.current) {
      return
    }
    setPassos(stepper.current.currentStepIndex + 1)
    stepper.current.goNext()
  }
  const datasend = new FormData()

  //INICIO SUBMIT FORM
  const submitStep = async (values: ICreateLicense, actions: FormikValues) => {
    console.log('EDIT LICENÇA VALORES', values)
    if (!stepper.current) {
      return
    }
    setCurrentSchema(createLicenseSchemas[stepper.current.currentStepIndex])
    if (stepper.current.currentStepIndex !== totalpassos) {
      nextStep()
    } else {
      if (initValues.maintenance_cost !== values.maintenance_cost) {
        if (values.maintenance_cost)
          values.maintenance_cost = values.maintenance_cost.replaceAll('.', '')
        datasend.append('maintenance_cost', values.maintenance_cost?.toString() || '')
        console.log('MAINTENANCE COST', datasend.get('maintenance_cost'))
      }
      if (initValues.issue_cost !== values.issue_cost) {
        if (values.issue_cost) values.issue_cost = values.issue_cost.replaceAll('.', '')
        datasend.append('issue_cost', values.issue_cost?.toString() || '')
        console.log('ISSUE COST', datasend.get('issue_cost'))
      }
      if (initValues.renovation_cost !== values.renovation_cost) {
        if (values.renovation_cost)
          values.renovation_cost = values.renovation_cost.replaceAll('.', '')
        datasend.append('renovation_cost', values.renovation_cost?.toString() || '')
        console.log('RENOVATION COST', datasend.get('renovation_cost'))
      }
      // datasend.append('maintenance_cost', values.maintenance_cost?.toString() || '')
      // datasend.append('issue_cost', values.issue_cost?.toString() || '')
      // datasend.append('renovation_cost', values.renovation_cost?.toString() || '')
      datasend.append('description', values.description)
      datasend.append('license_number', values.license_number)
      datasend.append('status', values.status)
      datasend.append('project_id', values.project_id?.toString() || '')
      datasend.append('license_type_id', values.license_type_id?.toString() || '')
      datasend.append('issue_organ_id', values.issue_organ_id?.toString() || '')
      datasend.append('issue_date', values.issue_date)
      datasend.append('expiration_date', values.expiration_date)
      datasend.append('limit_renovation', values.limit_renovation)
      datasend.append('finalization_date', values.finalization_date?.toString() || '')
      datasend.append('control_conditionings', values.control_conditionings?.toString() || '')
      datasend.append('responsible', values.responsible || '')
      // datasend.append('renovation_alert_days[]', values.renovation_alert_days.toString() || '')
      datasend.append('entrepreneur_id', values.entrepreneur_id.toString() || '')
      // datasend.append('responsible_id[]', values.responsiblesT?.toString() || '')
      // datasend.append('enterprise_id[]', values.enterprise_id?.toString() || '')
      // datasend.append('parent_id[]', values.parent_id?.toString() || '')
      // datasend.append('field_id[]', values.field_id.toString() || '')
      if (initValues.file !== values.file) {
        datasend.set('file', values.file as File)
      }

      if (values.renovation_alert_days) {
        let AlertDays = values.renovation_alert_days as any

        for (let i = 0; i < AlertDays.length; i++) {
          let convert: any = AlertDays[i]
          if (convert.label) {
            datasend.append('renovation_alert_days[]', convert.value)
          } else {
            datasend.append('renovation_alert_days[]', convert)
          }
        }
        console.log('renovation_alert_days[]', datasend.getAll('renovation_alert_days[]'))
      }

      if (values.parent_id) {
        for (const element of values.parent_id) {
          let convert: any = element
          datasend.append('parent_id[]', convert.code)
        }
      }

      if (values.responsiblesT) {
        for (const element of values.responsiblesT) {
          let convert: any = element
          datasend.append('responsible_id[]', convert.code)
        }
      }

      if (values.field_id) {
        for (const element of values.field_id) {
          let convert: any = element
          datasend.append('field_id[]', convert.code)
        }
      }

      if (values.enterprise_id) {
        console.log('values.responsiblesT', values.enterprise_id)
        for (const element of values.enterprise_id) {
          let convert: any = element
          datasend.append('enterprise_id[]', convert.code)
        }
      }

      //auto preenchimento para teste
      //datasend.append('renovation_alert_days[]', '15')
      // datasend.append('responsible_id[]', '1')
      // datasend.append('field_id[]', '1')

      // await axios.post(`${API_URL}/sga/v1/licenses/update_license/${data?.uuid}`, datasend, {
      //   headers: {
      //     'Content-Type': 'multipart/form-data',
      //   },
      // })

      try {
        setLoading(true)
        await axios({
          method: 'post',
          url: `${API_URL}/sga/v1/licenses/update_license/${data?.uuid}`,
          data: datasend,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'LICENSES.SWAL_ADD'}),
          showConfirmButton: false,
          timer: 2000,
        })
        setLoading(false)
        navigate(`/editlicenses/${data?.id}/${data?.uuid}`)
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'LICENSES.SWAL_ADD_ERROR'}) + error,
          showConfirmButton: false,
          timer: 2000,
        })
        setLoading(false)
      }
      actions.resetForm()
    }
  }

  useEffect(() => {
    if (!stepperRef.current) {
      return
    }

    loadStepper()
  }, [stepperRef])

  setTimeout(() => {
    setTimeLoad(true)
  }, 2000)

  return (
    <div
      ref={stepperRef}
      className='stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid'
      id='kt_create_account_stepper'
    >
      <AnimaBaixo>
        <div className='card d-flex justify-content-center justify-content-xl-start flex-row-auto w-100 w-xl-300px w-xxl-400px me-9'>
          <div className='card-body px-6 px-lg-10 px-xxl-15 py-10'>
            <div className='stepper-nav'>
              <div
                className='stepper-item current'
                data-kt-stepper-element='nav'
                data-kt-stepper-action='step'
                onClick={() => clickStep(1)}
              >
                <div className='stepper-wrapper'>
                  <div className='stepper-icon w-30px h-30px'>
                    <i className='stepper-check fas fa-check'></i>
                    <span className='stepper-number'>1</span>
                  </div>

                  <div className='stepper-label'>
                    <h5 className='stepper-title fs-6'>
                      {intl.formatMessage({id: 'LICENSES.TITLE_STEAP1'})}
                    </h5>
                    <div className='stepper-desc fw-semibold fs-8'>
                      {intl.formatMessage({id: 'LICENSES.SUBTITLE2_STEAP1'})}
                    </div>
                  </div>
                </div>

                <div className='stepper-line h-30px'></div>
              </div>

              <div
                className='stepper-item'
                data-kt-stepper-element='nav'
                data-kt-stepper-action='step'
                onClick={() => clickStep(2)}
              >
                <div className='stepper-wrapper'>
                  <div className='stepper-icon w-30px h-30px'>
                    <i className='stepper-check fas fa-check'></i>
                    <span className='stepper-number'>2</span>
                  </div>

                  <div className='stepper-label'>
                    <h5 className='stepper-title fs-6'>
                      {intl.formatMessage({id: 'LICENSES.TITLE_STEAP2'})}
                    </h5>
                    <div className='stepper-desc fw-semibold fs-8'>
                      {intl.formatMessage({id: 'LICENSES.SUBTITLE_STEAP2'})}
                    </div>
                  </div>
                </div>

                <div className='stepper-line h-30px'></div>
              </div>

              <div
                className='stepper-item'
                data-kt-stepper-element='nav'
                data-kt-stepper-action='step'
                onClick={() => clickStep(3)}
              >
                <div className='stepper-wrapper'>
                  <div className='stepper-icon w-30px h-30px'>
                    <i className='stepper-check fas fa-check'></i>
                    <span className='stepper-number'>3</span>
                  </div>

                  <div className='stepper-label'>
                    <h5 className='stepper-title fs-6'>
                      {intl.formatMessage({id: 'LICENSES.TITLE_STEAP1'})}
                    </h5>
                    <div className='stepper-desc fw-semibold fs-8'>
                      {intl.formatMessage({id: 'LICENSES.SUBTITLE2_STEAP3'})}
                    </div>
                  </div>
                </div>

                <div className='stepper-line h-30px'></div>
              </div>
              <div
                className='stepper-item'
                data-kt-stepper-element='nav'
                data-kt-stepper-action='step'
                onClick={() => clickStep(4)}
              >
                <div className='stepper-wrapper'>
                  <div className='stepper-icon w-30px h-30px'>
                    <i className='stepper-check fas fa-check'></i>
                    <span className='stepper-number'>4</span>
                  </div>

                  <div className='stepper-label'>
                    <h5 className='stepper-title fs-6'>
                      {intl.formatMessage({id: 'LICENSES.TITLE_STEAP4'})}
                    </h5>
                    <div className='stepper-desc fw-semibold fs-8'>
                      {intl.formatMessage({id: 'LICENSES.SUBTITLE2_STEAP4'})}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </AnimaBaixo>

      <div className='d-flex flex-row-fluid flex-center bg-body rounded'>
        <Formik validationSchema={currentSchema} initialValues={initValues} onSubmit={submitStep}>
          {() => (
            <Form className='py-15 p-20 w-100 w-xl-1200px ' noValidate id='kt_create_account_form'>
              <div className='current' data-kt-stepper-element='content'>
                {timeLoad ? (
                  <Step1 />
                ) : (
                  <>
                    {' '}
                    <div className='col-12'>
                      <Skeleton className='mb-2'></Skeleton>
                      <Skeleton width='10rem' className='mb-2'></Skeleton>
                      <Skeleton width='5rem' className='mb-2'></Skeleton>
                      <Skeleton height='2rem' className='mb-2'></Skeleton>
                      <Skeleton width='10rem' height='4rem'></Skeleton>
                      <Skeleton className='mb-2'></Skeleton>
                      <Skeleton width='10rem' className='mb-2'></Skeleton>
                      <Skeleton width='5rem' className='mb-2'></Skeleton>
                      <Skeleton height='2rem' className='mb-2'></Skeleton>
                      <Skeleton className='mb-2'></Skeleton>
                      <Skeleton width='10rem' className='mb-2'></Skeleton>
                      <Skeleton width='5rem' className='mb-2'></Skeleton>
                      <Skeleton height='2rem' className='mb-2'></Skeleton>
                    </div>
                  </>
                )}
              </div>

              <div data-kt-stepper-element='content'>
                {timeLoad ? <Step2 /> : <CardLoading height='100px' width='120px' />}
              </div>

              <div data-kt-stepper-element='content'>
                {timeLoad ? <Step3 /> : <CardLoading height='100px' width='120px' />}
              </div>

              <div data-kt-stepper-element='content'>
                {timeLoad ? <Step4 /> : <CardLoading height='100px' width='120px' />}
              </div>

              <div className='d-flex flex-stack  pt-10'>
                <div className='mr-2'>
                  <button
                    onClick={prevStep}
                    type='button'
                    className='btn btn-sm btn-lg btn-light-primary me-3'
                    data-kt-stepper-action='previous'
                  >
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr063.svg'
                      className='svg-icon-4 me-1'
                    />
                    {intl.formatMessage({id: 'COMMON.BACK_BUTTON'})}
                  </button>
                </div>

                <div>
                  <button
                    type='submit'
                    className='btn btn-sm btn-lg btn-primary me-3'
                    disabled={loading}
                  >
                    {!loading && (
                      <span className='indicator-label'>
                        {passos !== totalpassos && intl.formatMessage({id: 'COMMON.NEXT'})}
                        {passos === totalpassos && intl.formatMessage({id: 'COMMON.SAVE_BUTTON'})}
                        {passos !== totalpassos && (
                          <KTSVG
                            path='/media/icons/duotune/arrows/arr064.svg'
                            className='svg-icon-3 ms-2 me-0'
                          />
                        )}
                      </span>
                    )}
                    {loading && (
                      <span className='indicator-progress' style={{display: 'block'}}>
                        {intl.formatMessage({id: 'COMMON.SAVING_BUTTON'})}{' '}
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  )
}

export {Vertical}
